import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import './FAQModal.css';

const FAQModal = ({ isOpen, onClose }) => {
  const [openFAQ, setOpenFAQ] = useState(0); // First FAQ open by default

  const faqs = [
    {
      question: "What is this all about?",
      answer: (
        <div>
          <p>Many things happen in our lives that we experience as mistakes. Often we can't even process them. We have no one to share them with. By sharing these on the GuiltBox platform:</p>
          <ol>
            <li><strong>It becomes easier to accept and process them.</strong> Whatever it's about, by telling your story, you're on the right path to putting it behind you.</li>
            <li><strong>Something good even comes from your story.</strong> By sharing your story with the GuiltBox community, you raise donations for causes close to your heart.</li>
          </ol>
        </div>
      )
    },
    {
      question: "What kind of story should I share?",
      answer: (
        <div>
          <p>Anything that's on your mind. Arguments, mistakes, anger, carelessness? Think of GuiltBox as your own personal audio diary! Just tell them honestly and the events will end with a positive outcome! By telling your story, you're supporting good causes. The community appreciates this. Thank you!</p>
        </div>
      )
    },
    {
      question: "How does a confession become a donation?",
      answer: (
        <div>
          <p>Your story becomes a decentralized token on the Zora platform. This creates tradeable value behind your story. If the community wants to comment on your story, they need to buy your token. If your story is longer than 10 seconds, they can only listen to the full version if they own your story's token. This way the community starts trading the tokens, and after each trade, donations go to the organizations you selected.</p>
        </div>
      )
    },
    {
      question: "How do these donations reach the recipients?",
      answer: (
        <div>
          <p>Donations first go to a collection account created by the GuiltBox platform. Each organization has a separate account. We transfer the collected donations monthly through <a href="https://www.cryptoforcharity.io/" target="_blank" rel="noopener noreferrer">Crypto for Charity</a>. You can view the exact wallet addresses of the collection accounts by clicking on Supported Charities.</p>
        </div>
      )
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="faq-modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="faq-modal"
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="faq-modal-header">
            <h2>Frequently Asked Questions</h2>
            <button 
              className="faq-modal-close"
              onClick={onClose}
              aria-label="Close FAQ"
            >
              <X size={24} />
            </button>
          </div>

          <div className="faq-modal-content">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button
                  className={`faq-question ${openFAQ === index ? 'active' : ''}`}
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  {openFAQ === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
                
                <AnimatePresence>
                  {openFAQ === index && (
                    <motion.div
                      className="faq-answer"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                      <div className="faq-answer-content">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FAQModal;